import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachincholitouristattraction() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Tourist Attractions Nearby Pune',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Tourist Attractions Nearby Pune',
        headingDescription: 'If you are looking for a peaceful escape surrounded by nature and culture, Anand Krushi Paryatan Kendra is one of the top Morachi Chincholi tourist attractions nearby Pune. Located just 55 km from the city, this 40-acre agri-tourism center offers a perfect blend of rural charm and modern enjoyment. Ideal for families, school picnics, and corporate outings, the farm provides a full day of immersive experiences such as bullock cart rides, tractor rides, horse riding, boating, swimming, and fun rain dance activities. Guests can also enjoy puppet shows, magic performances, and a variety of adventure and village games.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Peacock Watching in Natural Habitat",
    "description": "Morachi Chincholi is famously home to over 2,500 free-roaming peacocks. Early mornings and evenings offer the best chance to spot them dancing, calling, or gliding through the skies across farms and fields — a surreal sight for nature lovers and photographers."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "A 40-acre agri-tourism park offering tractor safaris, organic farming demos, bullock-cart rides, rural games, dairy activities, and authentic Maharashtrian meals. A perfect rural retreat for families, schools, and nature seekers just an hour from Pune."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Enjoy scenic rides through the countryside on traditional bullock carts or vibrant tractors. A nostalgic, slow-paced way to explore rural trails surrounded by sugarcane, sunflower, and marigold fields."
  },
  {
    "title": "Hurda Parties (Winter Special)",
    "description": "From November to February, join locals in celebrating the harvest season by enjoying roasted green jowar (hurda) with chutneys and jaggery under open skies, often accompanied by folk music and dance."
  },
  {
    "title": "Morachi Chincholi Bird Watching Trail",
    "description": "Besides peacocks, this region is rich in birdlife like kingfishers, parakeets, bulbuls, and bee-eaters. Morning treks through trails near village ponds and banyan trees are peaceful and rewarding for birdwatchers."
  },
  {
    "title": "Local Village Folk Shows & Puppet Performances",
    "description": "Watch vibrant rural performances including lavani dance, tamasha, dholki bhajan sessions, and puppet shows — typically organized during weekends and festive events at local tourism centers."
  },
  {
    "title": "Traditional Maharashtrian Meals",
    "description": "Relish piping-hot zunka-bhakar, pithla, bharli vangi, varan-bhat, chutneys, and sweets served on banana leaves — cooked over firewood stoves using fresh farm ingredients."
  },
  {
    "title": "Rural Kids' Fun Zone",
    "description": "Slides, swings, rope bridges, and tire games await children. A safe, clean, and nature-surrounded play area ideal for school picnics and family visits."
  },
  {
    "title": "Sunset Views from Sugarcane Fields",
    "description": "Golden-hour walks along the edges of sugarcane and mustard fields provide postcard-worthy sunset views — perfect for slow travelers, photographers, and nature lovers."
  },
  {
    "title": "Camping & Bonfire Nights",
    "description": "Some agri-tourism farms offer overnight camping with tents, bonfires, folk music, and star gazing experiences — a rustic and memorable escape from city life."
  }
],




"services": [
  {
    "name": "Must-Visit Tourist Spots Near Morachi Chincholi",
    "description": "Explore a curated list of must-visit destinations around Morachi Chincholi, including Anand Krushi Paryatan Kendra. From bird sanctuaries to agro-tourism centers, this region offers a perfect blend of nature, culture, and rural charm ideal for families and weekend travelers."
  },
  {
    "name": "Nature Parks and Gardens",
    "description": "Discover lush nature parks and orchards near Morachi Chincholi. Anand Krushi Paryatan Kendra features open green fields, mango plantations, and serene walking trails that provide a perfect natural escape for nature lovers and photographers."
  },
  {
    "name": "Historical Landmarks",
    "description": "Within a short drive, visit nearby forts, temples, and heritage structures that reflect Maharashtra’s rich history. Anand Krushi Paryatan Kendra often integrates heritage storytelling into its cultural programs, offering historical context with a rural twist."
  },
  {
    "name": "Cultural Centers and Museums",
    "description": "Enhance your cultural experience with local folk music nights, rural theater, and traditional art forms. While not a formal museum, Anand Krushi Paryatan Kendra acts as a living culture center, preserving and celebrating local heritage through performances and exhibits."
  },
  {
    "name": "Wildlife Sanctuaries Nearby",
    "description": "Located in a peacock sanctuary zone, the farm is a hotspot for birdwatching. Nature enthusiasts can also explore nearby wildlife sanctuaries or forested zones where native flora and fauna thrive."
  },
  {
    "name": "Adventure Activity Centers",
    "description": "Enjoy rustic adventure at Anand Krushi Paryatan Kendra with activities like rope climbing, tire walks, tractor rides, and rural obstacle courses—perfect for school groups, families, and team outings."
  },
  {
    "name": "Local Markets and Bazaars",
    "description": "Explore traditional rural markets near Morachi Chincholi offering fresh produce, handicrafts, and farm-made products. Anand Krushi Paryatan Kendra features its own farm stall with jaggery, pickles, grains, and seasonal fruits."
  },
  {
    "name": "Scenic Viewpoints",
    "description": "Capture breathtaking views of farmland, orchards, and open countryside. Sunrise and sunset at Anand Krushi Paryatan Kendra provide beautiful natural backdrops perfect for photography and quiet reflection."
  },
  {
    "name": "Religious and Spiritual Places",
    "description": "Visit serene temples and spiritual sites around Morachi Chincholi. Many guests combine spiritual visits with a peaceful retreat at Anand Krushi Paryatan Kendra, making for a wholesome day outing."
  },
  {
    "name": "Picnic Areas and Parks",
    "description": "Anand Krushi Paryatan Kendra offers dedicated picnic spaces with natural shade, seating, and clean surroundings. Ideal for family picnics, school trips, or community get-togethers in a rustic setting."
  },
  {
    "name": "Eco-Tourism Hubs",
    "description": "As an eco-conscious center, Anand Krushi Paryatan Kendra promotes sustainability through organic farming, rainwater harvesting, and nature education. It’s a leading example of eco-tourism in the Morachi Chincholi region."
  },
  {
    "name": "Family Outing Spots",
    "description": "Safe, clean, and interactive—this farm is a top destination for families. From cultural shows to bullock cart rides and outdoor games, every member of the family finds something engaging to enjoy."
  },
  {
    "name": "Waterfall Visits",
    "description": "During the monsoon, nearby seasonal waterfalls become popular spots for quick visits. Combine such scenic stops with a relaxing farm lunch or agro-tourism experience at Anand Krushi Paryatan Kendra."
  },
  {
    "name": "Heritage Sites",
    "description": "Several heritage temples and ancient village sites surround Morachi Chincholi. The farm itself is a cultural heritage site in the making, celebrating age-old farming practices and rural wisdom."
  },
  {
    "name": "Resorts and Relaxation Spots",
    "description": "Anand Krushi Paryatan Kendra doubles as a relaxation retreat with cottages, hammocks, nature trails, and traditional meals. Whether it’s a day trip or overnight stay, visitors enjoy a mix of rest and rural adventure."
  }
],
"tableData": [
  ["Must-Visit Tourist Spots Near Morachi Chincholi", "- Nature Parks and Gardens"],
  ["Historical Landmarks", "- Cultural Centers and Museums"],
  ["Wildlife Sanctuaries Nearby", "- Adventure Activity Centers"],
  ["Local Markets and Bazaars", "- Scenic Viewpoints"],
  ["Religious and Spiritual Places", "- Picnic Areas and Parks"],
  ["Eco-Tourism Hubs", "- Family Outing Spots"],
  ["Waterfall Visits", "- Heritage Sites"],
  ["Resorts and Relaxation Spots", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Peacock Sanctuary in Morachi Chincholi",
    "WhyChoosedescription": "Home to over 2,500 free-roaming peacocks, Morachi Chincholi is famous for its vibrant birdlife and tamarind groves. Visitors can enjoy early morning or evening peacock sightings, a rare experience so close to Pune."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "A popular agro-tourism center that offers bullock cart rides, tractor tours, farm visits, and delicious farm-fresh Maharashtrian meals. It’s a perfect rural escape for families and school or corporate groups."
  },
  {
    "WhyChooseheading": "Nighoj Potholes and Jain Temple",
    "WhyChoosedescription": "Located around 25 km from Morachi Chincholi, the Kukadi River has carved natural potholes in the basalt rock at Nighoj. The nearby ancient Jain temple adds spiritual significance to this geological marvel."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "This lesser-known historical site about 20 km from Morachi Chincholi offers panoramic views and insights into Maratha history. Ideal for a short, peaceful excursion."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "A serene picnic spot near Shirur, Vadgaon Dam is surrounded by natural beauty, making it a perfect place for relaxation, photography, and enjoying a calm lakeside breeze."
  },
  {
    "WhyChooseheading": "Ramling Mandir",
    "WhyChoosedescription": "Dedicated to Lord Shiva, this peaceful temple is about 30 km from Morachi Chincholi. Its calm and spiritual atmosphere makes it a great spot for meditation and quiet reflection."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "One of the Ashtavinayak temples of Maharashtra, Ranjangaon Ganpati is just 40–45 km away. A spiritually significant stop on your way to or from Morachi Chincholi."
  },
  {
    "WhyChooseheading": "Bhuleshwar Temple",
    "WhyChoosedescription": "About 50 km away, Bhuleshwar is a 13th-century Shiva temple known for its carvings and serene hilltop views. A great stop for history buffs and architecture enthusiasts."
  }
]











    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the top tourist attractions in Morachi Chincholi?',
    answer: 'Top attractions include the Peacock Sanctuary, Anand Krushi Paryatan Kendra (agro-tourism), nature trails, bullock cart rides, butterfly parks, and traditional village experiences.',
  },
  {
    id: 'FAQ2',
    question: 'What makes the Peacock Sanctuary special?',
    answer: 'Morachi Chincholi is home to hundreds of Indian peacocks in their natural habitat. Visitors can witness them roaming freely—especially during early mornings and monsoon.',
  },
  {
    id: 'FAQ3',
    question: 'What are the nearby attractions from Morachi Chincholi?',
    answer: 'Nearby tourist spots include Ranjangaon Mahaganpati (Ashtavinayak temple), Alandi Temple, Jejuri Khandoba Temple, and Shikrapur sugar factories (educational visits).',
  },
  {
    id: 'FAQ4',
    question: 'How far is Morachi Chincholi from Pune?',
    answer: 'Morachi Chincholi is about 65 km from Pune, roughly a 1.5-hour drive via Alandi or Chakan.',
  },
  {
    id: 'FAQ5',
    question: 'Is Anand Krushi Paryatan Kendra worth visiting?',
    answer: 'Yes! It offers an engaging agro-tourism experience with pony rides, tractor tours, butterfly gardens, and local food, perfect for families and school groups.',
  },
  {
    id: 'FAQ6',
    question: 'Can I visit these attractions in one day?',
    answer: 'Yes, a well-planned one-day trip can include Morachi Chincholi, the peacock sanctuary, and a visit to Ranjangaon Temple or Alandi.',
  },
  {
    id: 'FAQ7',
    question: 'Are these places suitable for kids and elders?',
    answer: 'Absolutely. Most attractions are flat, shaded, and include activities suitable for all age groups, with rest areas and food availability.',
  },
  {
    id: 'FAQ8',
    question: 'When is the best time to explore Morachi Chincholi and surroundings?',
    answer: 'The monsoon to early winter season (June to November) is best due to greenery, mild weather, and peak peacock activity.',
  },
  {
    id: 'FAQ9',
    question: 'What cultural or spiritual spots can I explore nearby?',
    answer: 'You can visit Alandi (Sant Dnyaneshwar Samadhi Mandir), Ranjangaon Ganpati, and Jejuri Temple—all significant spiritual sites within 30–60 km radius.',
  },
  {
    id: 'FAQ10',
    question: 'Do I need to hire a guide or book in advance?',
    answer: 'Pre-booking is advised for agro-tourism experiences and large groups. Local guides are available for temple and cultural site visits upon request.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Swati Joshi, Pune',
    feedback: "We visited Morachi Chincholi and Ranjangaon on the same day. The peacocks were a sight to behold! Anand Krushi was perfect for kids and the food was authentic.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Raghav Gole, Navi Mumbai',
    feedback: "We planned a weekend around Morachi Chincholi. The blend of nature, culture, and village life made it an unforgettable rural tourism experience.",
    rating: 5,
  },
];












    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Tourist Attractions Nearby Pune",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-tourist-attractions.jpg",
  "description": "Discover the top tourist attractions near Morachi Chincholi, Pune. Explore nature parks, wildlife sanctuaries, heritage landmarks, picnic spots, waterfalls, and eco-tourism hubs perfect for family outings and nature lovers.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2178"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "550",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/morachi-chincholi-tourist-attractions"
  }
};



    return (
        <div>

<Helmet>
  <title>Morachi Chincholi Tourist Attractions Nearby Pune | Nature, Heritage & Family Spots | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Explore the best tourist attractions near Morachi Chincholi Pune — including cultural sites, nature parks, waterfalls, spiritual places, adventure hubs, and family-friendly picnic areas. Ideal for weekend trips and getaways." 
  />
  <meta 
    name="keywords" 
    content="Must-visit tourist spots near Morachi Chincholi, Nature parks and gardens, Historical landmarks, Cultural centers and museums, Wildlife sanctuaries nearby, Adventure activity centers, Local markets and bazaars, Scenic viewpoints, Religious and spiritual places, Picnic areas and parks, Eco-tourism hubs, Family outing spots, Waterfall visits, Heritage sites, Resorts and relaxation spots" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachincholitouristattraction;